import React, { useState } from "react";
import { timeDifferenceForDate } from "../utils";
import { useTheme, useThemeUpdate } from "../contexts/ThemeContext";
import PopupMenu from "../components/PopupMenu";
import "./BookmarkMagazine.css";

const BookmarkMagazine = (props) => {
    const theme = useTheme();

    function getBestValue(value, editedValue) {
        if (editedValue) {
            return editedValue;
        } else {
            return value;
        }
    }

    console.log(props.bookmarks);

    return (
        <div className="posts-news-container-magazine">
            <div>
                {props.bookmarks.edges.map((edge, index) => (
                    <div className={`posts-news-post-magazine`} key={index}>
                        <div
                            id={edge.node.post.id}
                            className="posts-news-item-magazine"
                            key={edge.node.post.id}
                        >
                            <div className={`posts-content-container-magazine`}>
                                <div
                                    className={`news-image-container-magazine`}
                                >
                                    <img
                                        alt=""
                                        className="posts-post-image-magazine"
                                        src={edge.node.post.image_url}
                                    />
                                </div>
                                <div className={`post-content-magazine`}>
                                    <div
                                        href="#"
                                        className="news-headline-link-magazine"
                                    >
                                        <h1
                                            onClick={props.onHeadlineClick}
                                            className={`posts-news-headline-magazine theme-${theme.foreground}`}
                                            data-title={edge.node.post.title}
                                            data-body={edge.node.post.body}
                                            data-link={edge.node.post.link}
                                            data-postid={edge.node.post.id}
                                            data-img={edge.node.post.image_url}
                                            data-html={edge.node.post.body_html}
                                            data-created={
                                                edge.node.post.created
                                            }
                                            data-source={getBestValue(
                                                edge.node.post.source.name,
                                                edge.node.post.source
                                                    .edited_name
                                            )}
                                        >
                                            {edge.node.post.title}
                                        </h1>
                                    </div>

                                    <p
                                        className={`posts-news-content-magazine theme-${theme.paragraph}`}
                                    >
                                        {edge.node.post.body_short}
                                    </p>
                                    <div className="posts-meta-data-magazine">
                                        <h3
                                            className={`posts-source-magazine theme-${theme.paragraph}`}
                                        >
                                            {getBestValue(
                                                edge.node.post.source.name,
                                                edge.node.post.source
                                                    .edited_name
                                            ) + " / "}
                                            {timeDifferenceForDate(
                                                edge.node.post.created
                                            )}
                                        </h3>
                                    </div>
                                </div>
                            </div>

                        <div className="pop-up-menu-container-magazine">
                            <PopupMenu
                                user={props.user}
                                settings={props.settings}
                                postId={edge.node.post.id}
                                isActivated={props.articleMenuActive}
                                postLink={edge.node.post.link}
                                postTitle={edge.node.post.title}
                            />
                        </div>
                        </div>

                    </div>
                ))}
            </div>
        </div>
    );
};

export default BookmarkMagazine;
